import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";

import { ThemeProvider } from "@material-ui/core/styles";

import Router from "navigation";

import GlobalPopup from "services/popup";
import GlobalSnackbarContext from "services/snackbar/snackbarContext";
import Snackbar, { SNACKBAR_TYPES } from "components/Snackbar";

import { version } from "common/../../package.json";
import { environmentName } from "utils/env";

import { DEFAULT_THEME } from "constants/theme";

import { Version } from "./styles";

@observer
export default class App extends React.Component {
  @observable snackbarMessage: string = "";
  @observable snackbarType: string = SNACKBAR_TYPES.INFO;

  setMessage = (message: string, type: string = SNACKBAR_TYPES.INFO) => {
    this.snackbarMessage = message;
    this.snackbarType = type;
  };

  onSnackbarClose = () => {
    this.snackbarMessage = "";
    this.snackbarType = SNACKBAR_TYPES.INFO;
  };

  render(): React.ReactNode {
    return (
      <>
        <ThemeProvider theme={DEFAULT_THEME}>
          <GlobalSnackbarContext.Provider
            value={{ setMessage: this.setMessage }}
          >
            <Router />
            <GlobalPopup />
            <Version>{version + "\n" + environmentName}</Version>
          </GlobalSnackbarContext.Provider>
          <Snackbar
            message={this.snackbarMessage}
            onClose={this.onSnackbarClose}
            type={this.snackbarType}
          />
        </ThemeProvider>
      </>
    );
  }
}
